import { Component, Injector, Input, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * TownPlanning Widget
 */
@Component({
  selector: 'town-planning-widget',
  templateUrl: './town-planning-widget.component.html',
  styleUrls: ['./town-planning-widget.component.scss', '../../common/css/general.scss']
})
export class TownPlanningWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

    /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'townPlanning', false);
  }

  /**
   * Widget's text area options (if used)
   */
  textAreaOptions: any = null;

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    const self = this;//Kendo - keep it
    this.textAreaOptions = {
      change: function () {
        self.setDirtyFlag(true);
      },
      update: function (text) {
        self.widgetData.Comment = text;
      },
      activateWidgetFunction: this.activateWidgetForHashtag
    };


    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("townplanning", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    if (!this.widgetConfig.hashtagSupported) {
      this.widgetConfig.hashtagSupported = true;
    }
    this.loadReflist('ref_use_class_items');

    this.mockupData$ = this.widgetService.loadMockup('townplanning');

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('townplanning', this.getReport());
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

  /**
   * Function executed when hashtag is detected in widget
   */
  activateWidgetForHashtag() {
    this.page.document.main.setActiveWidgetForHashtag(this);
  }
}
